import  { useState } from 'react';
import { Footer } from '../../../components/footer';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetRankDetails, useGetRankHistory, useUserGetRank } from '../api/dashboardApi';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';
import Loader from '../../Loader/buttonLoad';
import PropTypes from 'prop-types';


const RankRewardCard = ({ id, ranknum, dmNumber, teamcount, days, primaryleg, others, primaryInvestment, otherLegInvestment, selfInvestment, completedLevels, rank3UsersCount }) => {


    const { data: userRank } = useUserGetRank()
    const matchedRank = userRank?.matchedRank;
    const isRankFour = ranknum === '04';
    const rankNum = Number(ranknum);
    const rewardKey =
        matchedRank && rankNum
            ? `rank${rankNum}RewardDays`
            : null;

    const earnedDays =

        rewardKey && matchedRank
            ? matchedRank[rewardKey]
            : 0;
    const formatInvestment = (value) => {
        const num = parseFloat(value) || 0;
        return num <= 0 ? 0 : Number(num.toFixed(4));
    };
    return (
        <>
            <div className='row'>
                <div className="col-lg-12">
                    <div className="appcard mb-4 px-0 pb-2 cardbg">
                        <div className="cardHeader px-4">
                            <div className="d-flex justify-content-between">
                                <h5>Eligibility Criteria - Rank <span>0{id}</span></h5>
                                <div>
                                    <div >
                                        <span style={{ color: "#FCD535" }}>Reward Days:{days}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='px-4'>
                            <div className="row">
                                <div className="col-lg">
                                    <div className="row">
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Direct Members</div>
                                            <div className='fs-20 fw-600'>{dmNumber}</div>
                                        </div>
                                        {
                                            isRankFour &&
                                            <div className="col-md-4 col-sm-6 mb-3">
                                                <div className='text-white-60 fs-14 fw-400'>No of Rank 3 Users</div>
                                                <div className='fs-20 fw-600'>{rank3UsersCount}</div>
                                            </div>
                                        }



                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Team Count</div>
                                            <div className='fs-20 fw-600'>{teamcount}</div>
                                        </div>

                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Primary Leg</div>
                                            <div className='fs-20 fw-600'>{primaryleg}</div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Other Leg</div>
                                            <div className='fs-20 fw-600'>{others}</div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Primary Leg Investment</div>
                                            <div className='fs-20 fw-600'>{primaryInvestment} TPL</div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Other Leg Investment</div>
                                            <div className='fs-20 fw-600'>{otherLegInvestment} TPL</div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Self Investment</div>
                                            <div className='fs-20 fw-600'>{selfInvestment} TPL</div>
                                        </div>
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <div className='text-white-60 fs-14 fw-400'>Upgrade Levels</div>
                                            <div className='fs-20 fw-600'>{completedLevels}</div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-lg-12">
                    <div className="appcard mb-4 px-0 pb-2 cardbg">
                        <div className="cardHeader px-4">
                            <div className="d-flex justify-content-between">
                                <h5>My Achievements</h5>
                                <div>
                                    <span style={{ color: "#FCD535" }}>Earned Days:{earnedDays}</span>
                                </div>
                            </div>
                        </div>
                        <div className='px-4'>
                            <div className="row">
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Direct Members</div>
                                    <div className='fs-20 fw-600'>{userRank?.directCount || 0}</div>
                                </div>
                                {
                                    isRankFour &&
                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <div className='text-white-60 fs-14 fw-400'>No of Rank 3 Users</div>
                                        <div className='fs-20 fw-600'>{userRank?.matchedRank?.rank3UsersCount}</div>
                                    </div>
                                }

                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Team Count</div>
                                    <div className='fs-20 fw-600'>{userRank?.totalteam || 0}</div>
                                </div>

                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Primary Leg</div>
                                    <div className='fs-20 fw-600'>{userRank?.primaryLeg || 0}</div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Other Leg</div>
                                    <div className='fs-20 fw-600'>{userRank?.otherLeg || 0}</div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Primary Leg Investment</div>
                                    <div className='fs-20 fw-600'> {formatInvestment(userRank?.PrimaryInvestment)} TPL</div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Other Leg Investment</div>
                                    <div className='fs-20 fw-600'>
                                        {formatInvestment(userRank?.otherLegInvestment)} TPL</div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Self Investment</div>
                                    <div className='fs-20 fw-600'>
                                        {formatInvestment(userRank?.selfInvestment)} TPL</div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <div className='text-white-60 fs-14 fw-400'>Upgrade Levels</div>
                                    <div className='fs-20 fw-600'>{userRank?.completedLevel || 0}</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

const RankRewards = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const { data: rankData, isLoading: detailsLoading } = useGetRankDetails()

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { data: rankHistory, isLoading: RankLoading } = useGetRankHistory({ page, size: rowsPerPage, rank: `rank${id}` })
    const totalPages = rankHistory?.count ? Math.ceil(rankHistory.count / rowsPerPage) : 0;

    const handlePageChange = (newPage) => {
        const currentScrollY = window.scrollY;


        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY);
            });
        }
    };
    const items = rankData?.rankDetails?.map((rank, index) => ({
        id: index + 1,
        ranknum: (index + 1).toString().padStart(2, '0'),
        dmNumber: rank.direct || 0,
        teamcount: rank.totalTeam || 0,
        days: rank.days || 0,
        primaryleg: rank.primaryLeg || 0,
        others: rank.otherLeg || 0,
        primaryInvestment: rank.primaryInvestment || 0,
        otherLegInvestment: rank.otherLegInvestment || 0,
        selfInvestment: rank.selfInvestment || 0,
        completedLevels: rank.completedLevels || 0,
        rank3UsersCount: rank.rank3UsersCount || 0,
    }));
    const filteredItems = id ? items?.filter(item => item.id === Number(id)) : items;

    // Inside the same component, above the return:
    const formatAmount = (amount) => {
        if (!amount) return 0; // handles null/undefined/0

        const str = amount.toString();
        if (str.includes('.')) {
            return parseFloat(amount).toFixed(4);
        }
        return amount;
    };
    return (
        <>
            {(RankLoading || detailsLoading) && <Loader />}

            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/dashboard')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Rank Reward</span>
                        </div>

                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="row align-items-center">
                                    <div className="col-lg-12">
                                        {filteredItems?.map((item) => (
                                            <RankRewardCard
                                                key={item.id}
                                                id={item.id}
                                                ranknum={item.ranknum}
                                                dmNumber={item.dmNumber}
                                                teamcount={item.teamcount}
                                                days={item.days}
                                                primaryleg={item.primaryleg}
                                                others={item.others}
                                                primaryInvestment={item.primaryInvestment}
                                                otherLegInvestment={item.otherLegInvestment}
                                                selfInvestment={item.selfInvestment}
                                                completedLevels={item.completedLevels}
                                                rank3UsersCount={item.rank3UsersCount}
                                            />
                                        ))}
                                    </div>

                                </div>




                                <div className='row'>
                                    <div className="col-lg-12">
                                        <div className="appcard mb-4 px-0 pb-2 cardbg">
                                            <div className="cardHeader border-bottom-0 px-4 pb-0">

                                                <h5>Reward History</h5>
                                            </div>


                                            <div className="px-4 mb-3">
                                                <div className='row justify-content-between'>
                                                    <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                        <div className='d-inline-flex g-8 align-items-center'>
                                                            <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                            <div className='form-group mb-0 formInputs gradientBg'>
                                                                <select className='form-control' onChange={(e) => {
                                                                    setRowsPerPage(Number(e.target.value));
                                                                    setPage(0);
                                                                }}>
                                                                    <option value="10">10</option>
                                                                    <option value="30">30</option>
                                                                    <option value="50">50</option>
                                                                </select>
                                                            </div>
                                                            <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='table-responsive mb-3'>
                                                <table className='table myapptable table-hover table-borderless mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-center'>S.No</th>
                                                            <th className='text-center'>Reward Amount</th>
                                                            <th className='text-center pr-4'>Date & Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rankHistory?.data?.length > 0 ?
                                                            rankHistory?.data?.map((v, i) =>
                                                                <tr key={v?._id}>

                                                                    <td align='center'>{page * rowsPerPage + (i + 1)}</td>
                                                                    <td align='center'>
                                                                        {formatAmount(v?.amount)} USDT</td>
                                                                    <td className='text-center pr-4 text-nowrap'> <span>{moment(v?.createdAt).format("DD/MM/YYYY | hh:mm A")}</span></td>
                                                                </tr>
                                                            ) :
                                                            <tr>
                                                                <td colSpan="6" className="text-center">No data found</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {rankHistory?.count &&
                                                <div className="px-4">
                                                    <div className='row'>
                                                        <div className='col-lg-12'>

                                                            <Pagination aria-label="Page navigation" className='customPagination'>
                                                                <PaginationItem disabled={page === 0}>
                                                                    <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                                        <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                                <span className='number'>

                                                                    {page < 3 ? (
                                                                        // Show first three pages if the current page is less than 3
                                                                        Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                                            <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                                <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                                    {index + 1}
                                                                                </PaginationLink>
                                                                            </PaginationItem>
                                                                        ))
                                                                    ) : (
                                                                        // Show a dynamic range around the current page if the current page is 3 or greater
                                                                        <>
                                                                            {page > 0 && (
                                                                                <PaginationItem key={0} className="customPagination">
                                                                                    <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                                        1
                                                                                    </PaginationLink>
                                                                                </PaginationItem>
                                                                            )}

                                                                            {page > 1 && (
                                                                                <PaginationItem disabled>
                                                                                    <PaginationLink href="#">...</PaginationLink>
                                                                                </PaginationItem>
                                                                            )}

                                                                            {Array.from({ length: 3 }, (_, index) => (
                                                                                <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                                    <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                                        {page - 1 + index + 1}
                                                                                    </PaginationLink>
                                                                                </PaginationItem>
                                                                            ))}

                                                                            {page < totalPages - 2 && (
                                                                                <PaginationItem disabled>
                                                                                    <PaginationLink href="#">...</PaginationLink>
                                                                                </PaginationItem>
                                                                            )}

                                                                            {page < totalPages - 1 && (
                                                                                <PaginationItem key={totalPages - 1} className="customPagination">
                                                                                    <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                                        {totalPages}
                                                                                    </PaginationLink>
                                                                                </PaginationItem>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </span>

                                                                <PaginationItem disabled={page === totalPages - 1}>
                                                                    <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                                        Next <i className='bi bi-arrow-right align-bottom'></i>
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            </Pagination>
                                                        </div>
                                                    </div>
                                                </div>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
RankRewardCard.propTypes = {
    ranknum: PropTypes.any,
    dmNumber: PropTypes.any,
    teamcount: PropTypes.any,
    days: PropTypes.any,
    primaryleg: PropTypes.any,
    others: PropTypes.any,
    id: PropTypes.any,
    primaryInvestment: PropTypes.any,
    otherLegInvestment: PropTypes.any,
    selfInvestment: PropTypes.any,
    completedLevels: PropTypes.any,
    rank3UsersCount: PropTypes.any,

}
export default RankRewards;